import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { useDevToolsStore } from '@frontend/devtools';
import { useTranslation } from '@frontend/i18n';
import { ContentLoader } from '@frontend/design-system';
import { useManageAppointmentWriteback } from '../../../../../../hooks/scheduler-v3/use-manage-appointment-writeback';
import { ScheduleActionsContext, ScheduleActionsContextType } from '../../ScheduleActionsContext';
import { ScheduleRequestModalContext, ScheduleRequestModalContextType } from '../Context/ScheduleRequestModalContext';
import { ScheduleRequestModal } from '../ScheduleRequestModal';
import { ScheduleReadOnlyRequestModal } from '../ScheduleRequestModal/ScheduleReadOnlyRequestModal/ScheduleReadOnlyRequestModal';
import { ScheduleRequestContentWrapper } from '../ScheduleRequestModal/types';

type ScheduleRequestFormManagerProps = {
  scheduleRequestModalContextValue: ScheduleRequestModalContextType;
  selectedScheduleRequest: ScheduleRequest | undefined;
  wrapper: ScheduleRequestContentWrapper;
  scheduleActionsContextValue: ScheduleActionsContextType;
  isLoadingScheduleRequest?: boolean;
};
export const ScheduleRequestFormManager = ({
  wrapper: Wrapper,
  scheduleRequestModalContextValue,
  selectedScheduleRequest,
  scheduleActionsContextValue,
  isLoadingScheduleRequest = false,
}: ScheduleRequestFormManagerProps) => {
  const { t } = useTranslation('scheduleCalendarRequest');
  const locationId = selectedScheduleRequest?.locationId ?? '';

  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  const { appointmentWritebackSourceTenants, isLoadingDataSources, isLoadingSourceTenants } =
    useManageAppointmentWriteback({
      isEnabled: isIntegratedOffice,
      locationId: locationId,
    });

  const isLoading =
    isLoadingScheduleRequest || isLoadingIntegrationDetails || isLoadingDataSources || isLoadingSourceTenants;

  const isIntegratedWithoutWritebacks = isIntegratedOffice && !appointmentWritebackSourceTenants.length;

  const {
    options: { isDebugModeOn },
  } = useDevToolsStore();

  const { scheduleRequestModalProps, handleCloseScheduleRequestModal } = scheduleRequestModalContextValue;

  if (isLoading) {
    <Wrapper modalProps={scheduleRequestModalProps} onClose={handleCloseScheduleRequestModal}>
      <Wrapper.Header onClose={handleCloseScheduleRequestModal}>{t('Review Appointment Request')}</Wrapper.Header>
      <Wrapper.Content>
        <ContentLoader show />
      </Wrapper.Content>
    </Wrapper>;
  }

  if (!selectedScheduleRequest) {
    return null;
  }

  return (
    <ScheduleActionsContext.Provider value={scheduleActionsContextValue}>
      <ScheduleRequestModalContext.Provider value={scheduleRequestModalContextValue}>
        {isIntegratedWithoutWritebacks && !isDebugModeOn ? (
          <ScheduleReadOnlyRequestModal wrapper={Wrapper} />
        ) : (
          <ScheduleRequestModal
            wrapper={Wrapper}
            showWritebackWarning={isIntegratedWithoutWritebacks && isDebugModeOn}
          />
        )}
      </ScheduleRequestModalContext.Provider>
    </ScheduleActionsContext.Provider>
  );
};
